import 'alpinejs'

require('./bootstrap');

import Swiper from 'swiper';
import 'swiper/css/bundle';

// Quill Editor & Library
import Quill from "quill";
window.Quill = Quill;
import Parchment from 'parchment';
window.Parchment = Parchment;
window.QuillDeltaToHtmlConverter = require('quill-delta-to-html').QuillDeltaToHtmlConverter;

window.$ = window.jQuery = require('jquery');

// flatpickr (Date-picker)
import Flatpickr from "flatpickr";
window.Flatpickr = Flatpickr;
import 'flatpickr/dist/flatpickr.min.css';

// Sortable
import Sortable from 'sortablejs';
window.Sortable = Sortable;

// Tom Select
import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.css';
window.TomSelect = TomSelect;

require('jquery-datetimepicker/build/jquery.datetimepicker.full');
